module.exports = __webpack_public_path__ + "static/media/bid_caf_fonplata_footer.bc5f56bb.svg";